import React, { useCallback, useEffect, useState } from "react";
import { fetchGetAutorizacionesPendientes, fetchAutorizarUsuario } from "../services/userService";
import { useUserContext } from "../hooks/UserContext";
import { UserPayload } from "../models/SiteModel";
import { OperacionesAutorizables, OperacionesAutorizablesDescriptions } from "../models/AutorizacionesModel";
import { Box, Button, CircularProgress, Grid, IconButton, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNotification } from "../hooks/NotificationContext";

const AutorizacionOperacion = () => {
  const { getUser } = useUserContext();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [actionLoadingId, setActionLoadingId] = useState<number | undefined>(undefined);
  const [authorizations, setAuthorizations] = useState<any[]>([]);

  const getOperacionDescription = (operacionId: OperacionesAutorizables): string => {
    return OperacionesAutorizablesDescriptions[operacionId] || "Operacion desconocida";
  };

  const fetchAuthorizations = useCallback(async () => {
    setLoading(true);
    try {
      const user: UserPayload | undefined = getUser();
      if (!user) {
        setLoading(false);
        return;
      }
      const data = await fetchGetAutorizacionesPendientes(user);
      setAuthorizations(data);
    } catch (error) {
      console.error("Error fetching authorizations:", error);
    } finally {
      setLoading(false);
    }
  }, [getUser]);

  useEffect(() => {
    fetchAuthorizations();
  }, [fetchAuthorizations]);

  const handleAuthorize = async (idAutorizacion: number, idUsuario: number, ejecucionesPermitidas: number | undefined) => {
    setActionLoadingId(idAutorizacion);
    try {
      const user: UserPayload | undefined = getUser();
      if (!user) {
        return;
      }

      const result = await fetchAutorizarUsuario(user, idAutorizacion, idUsuario, ejecucionesPermitidas);

      if (result) {
        const message = ejecucionesPermitidas === -1 ? "Autorizacion rechazada con exito." : "Autorizacion realizada con exito.";
        showNotification(message, "success");
        setAuthorizations((prev) => prev.filter((auth) => auth.id_Autorizacion !== idAutorizacion));
      } else {
        showNotification("Error al realizar la accion.", "error");
      }
    } catch (error) {
      console.error("Error authorizing:", error);
      showNotification("Error al realizar la accion.", "error");
    } finally {
      setActionLoadingId(undefined);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h4" gutterBottom>
          Autorizaciones Pendientes
        </Typography>
        <IconButton color="primary" onClick={fetchAuthorizations} disabled={loading}>
          {loading ? <CircularProgress color="inherit" size={24} /> : <RefreshIcon />}
        </IconButton>
      </Box>
      {authorizations.length > 0 ? (
        <Grid container spacing={2}>
          {authorizations.map((auth) => (
            <Grid item xs={12} key={auth.id_Autorizacion}>
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography>
                  {getOperacionDescription(auth.operacion)} - Usuario: {auth.usuario}
                </Typography>
                <Box>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ mr: 1 }}
                    disabled={actionLoadingId === auth.id_Autorizacion}
                    startIcon={actionLoadingId === auth.id_Autorizacion ? <CircularProgress color="inherit" size={18} /> : undefined}
                    onClick={() => handleAuthorize(auth.id_Autorizacion, auth.id_Usuario, undefined)}
                  >
                    Autorizar
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    disabled={actionLoadingId === auth.id_Autorizacion}
                    startIcon={actionLoadingId === auth.id_Autorizacion ? <CircularProgress color="inherit" size={18} /> : undefined}
                    onClick={() => handleAuthorize(auth.id_Autorizacion, auth.id_Usuario, -1)}
                  >
                    Rechazar
                  </Button>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      ) : loading ? (
        <Typography>Cargando autorizaciones...</Typography>
      ) : (
        <Typography>No hay autorizaciones pendientes.</Typography>
      )}

    </Box>
  );
};

export default AutorizacionOperacion;

